import useApi from "@/services/useApi";
const { api } = useApi();

const numbersModule = {
    namespaced: true,
    // ARRAY (visible/invisible) [ VISIBLE_VALUE, INVISIBLE_VALUE ]
    state: {
        numbersViber: [],
        numbersTelegram: [],
        numbersWhatsapp: [],
        numbersDataViber: [],
        numbersDataTelegram: [],
        numbersDataWhatsapp: [],
        numbersDataAttributes: {
            loading: {
                viber: [false, false],
                telegram: [false, false],
                whatsapp: [false, false],
            },
            numberListPagination: {
                viber: [],
                telegram: [],
                whatsapp: [],
            },
            searchInput: {
                viber: ["", ""],
                telegram: ["", ""],
                whatsapp: ["", ""],
            },
        },
        selectedNumbers: {},
        preselectedNumbers: {
            viber: [],
            telegram: [],
            whatsapp: [],
        },
    },

    getters: {
        // GETTERS: NUMBERS (visble/invisible, viber/telegram/whatsapp)
        getVisibleNumbersViber(state) {
            return state.numbersDataViber[0];
        },
        getInvisibleNumbersViber(state) {
            return state.numbersDataViber[1];
        },
        getVisibleNumbersTelegram(state) {
            return state.numbersDataTelegram[0];
        },
        getInvisibleNumbersTelegram(state) {
            return state.numbersDataTelegram[1];
        },
        getVisibleNumbersWhatsapp(state) {
            return state.numbersDataWhatsapp[0];
        },
        getInvisibleNumbersWhatsapp(state) {
            return state.numbersDataWhatsapp[1];
        },
        // GETTERS: LOADING (visble/invisible, viber/telegram/whatsapp)
        getVisibleNumbersDataLoadingViber(state) {
            return state.numbersDataAttributes.loading.viber[0];
        },
        getVisibleNumbersDataLoadingTelegram(state) {
            return state.numbersDataAttributes.loading.telegram[0];
        },
        getVisibleNumbersDataLoadingWhatsapp(state) {
            return state.numbersDataAttributes.loading.whatsapp[0];
        },

        getInvisibleNumbersDataLoadingViber(state) {
            return state.numbersDataAttributes.loading.viber[1];
        },
        getInvisibleNumbersDataLoadingTelegram(state) {
            return state.numbersDataAttributes.loading.telegram[1];
        },
        getInvisibleNumbersDataLoadingWhatsapp(state) {
            return state.numbersDataAttributes.loading.whatsapp[1];
        },
        // GETTERS: ALL NUMBERS(old versions)
        getNumbersViber(state) {
            return state.numbersViber;
        },
        getNumbersTelegram(state) {
            return state.numbersTelegram;
        },

        getAllNumbers(state) {
            const sourceViber = state.numbersViber.map((number) => ({
                ...number,
                source: "viber",
            }));
            const sourceTelegram = state.numbersTelegram.map((t) => ({
                ...t,
                source: "telegram",
            }));
            const sourceWhatsapp = state.numbersWhatsapp.map((t) => ({
                ...t,
                source: "whatsapp",
            }));
            return [...sourceViber, ...sourceTelegram, ...sourceWhatsapp];
        },
    },
    actions: {
        async loadConnectedNumbers({ commit }) {
            const { headers } = useApi();
            await api
                .get("/api/numbers/connected", { headers })
                .then((response) => {
                    const { viber = [], telegram = [] } = response.data.data;

                    commit("SET_OLD_NUMBERS_VIBER", viber);
                    commit("SET_OLD_NUMBERS_TELEGRAM", telegram);

                    // if (
                    //     !response.data.data.viber.length &&
                    //     !response.data.data.telegram.length
                    // ) {
                    //     if (!isCookieSet("instructed")) {
                    //         commit("openDialog", "InstructionDialog", {
                    //             root: true,
                    //         });
                    //         setCookie("instructed", true);
                    //     }
                    // }
                })
                .catch((error) => {
                    throw error;
                });
        },
        setLoadingNumbers({ commit }, { messenger, value, visibility }) {
            switch (messenger) {
                case "viber":
                    commit(`SET_LOADING_NUMBERS_VIBER`, [value, visibility]);
                    break;
                case "telegram":
                    commit(`SET_LOADING_NUMBERS_TELEGRAM`, [value, visibility]);
                    break;
                case "whatsapp":
                    commit(`SET_LOADING_NUMBERS_WHATSAPP`, [value, visibility]);
                    break;
            }
        },
        setNumberListByMessenger(
            { commit, getters },
            { messenger, numberDataList, visibility }
        ) {
            switch (messenger) {
                case "viber":
                    commit(`SET_NUMBERS_VIBER`, [numberDataList, visibility]);
                    break;
                case "telegram":
                    commit(`SET_NUMBERS_TELEGRAM`, [
                        numberDataList,
                        visibility,
                    ]);
                    break;
                case "whatsapp":
                    commit(`SET_NUMBERS_WHATSAPP`, [
                        numberDataList,
                        visibility,
                    ]);
                    break;
            }
        },
        cleanNumberListByMessenger({ commit }, { messenger, visibility }) {
            const emptyList = [];
            switch (messenger) {
                case "viber":
                    commit(`SET_NUMBERS_VIBER`, [emptyList, visibility]);
                    break;
                case "telegram":
                    commit(`SET_NUMBERS_TELEGRAM`, [emptyList, visibility]);
                    break;
                case "whatsapp":
                    commit(`SET_NUMBERS_WHATSAPP`, [emptyList, visibility]);
                    break;
            }
        },
        setNumberListPagination(
            { commit },
            { messenger, paginationData, visibility }
        ) {
            switch (messenger) {
                case "viber":
                    commit(`SET_NUMBER_LIST_PAGINATION_VIBER`, [
                        paginationData,
                        visibility,
                    ]);
                    break;
                case "telegram":
                    commit(`SET_NUMBER_LIST_PAGINATION_TELEGRAM`, [
                        paginationData,
                        visibility,
                    ]);
                    break;
                case "whatsapp":
                    commit(`SET_NUMBER_LIST_PAGINATION_WHATSAPP`, [
                        paginationData,
                        visibility,
                    ]);
                    break;
            }
        },
        setSearchInput({ commit }, { messenger, input, visibility }) {
            switch (messenger) {
                case "viber":
                    commit(`SET_SEARCH_INPUT_VIBER`, [input, visibility]);
                    break;
                case "telegram":
                    commit(`SET_SEARCH_INPUT_TELEGRAM`, [input, visibility]);
                    break;
                case "whatsapp":
                    commit(`SET_SEARCH_INPUT_WHATSAPP`, [input, visibility]);
                    break;
            }
        },
        async loadNumbersByMessenger(
            { state, commit, getters, dispatch },
            {
                messenger,
                visibility,
                number = null,
                page = 1,
                isCollectData = true,
                prepayment = null,
                tariff_end_date = null,
            }
        ) {
            const { headers, reactiveHeaders } = useApi();
            const numberDataList = [];

            if (page === 1 || !isCollectData) {
                dispatch("cleanNumberListByMessenger", {
                    messenger,
                    visibility,
                });
            } else {
                const visibilityNumber = visibility ? "Visible" : "Invisible";
                const msgrUppercase =
                    messenger.charAt(0).toUpperCase() + messenger.slice(1);
                const getNumberData = `get${visibilityNumber}Numbers${msgrUppercase}`;

                isCollectData && numberDataList.push(...getters[getNumberData]);

                state.numbersDataAttributes.numberListPagination[messenger][
                    visibility ? 0 : 1
                ].current_page++;
            }

            dispatch("setLoadingNumbers", {
                messenger,
                visibility,
                value: true,
            });

            const queryParams = {
                messenger,
                visibility,
                number,
                page,
                prepayment,
                tariff_end_date,
            };
            // const start = performance.now()
            // console.debug(queryParams, start)
            await api
                .get("/api/numbers/connected/paginate", {
                    headers,
                    params: queryParams,
                })
                .then((response) => {
                    numberDataList.push(...response.data.data.numbers);

                    const paginationData = response.data.meta;

                    dispatch("setNumberListByMessenger", {
                        messenger,
                        numberDataList,
                        visibility,
                    });
                    dispatch("setNumberListPagination", {
                        messenger,
                        paginationData,
                        visibility,
                    });
                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                    // const finish = performance.now()
                    // console.debug(queryParams,+start.toFixed(2),+finish.toFixed(2), `(${((finish - start)/1000).toFixed(2)}s)`)
                    dispatch("setLoadingNumbers", {
                        messenger,
                        visibility,
                        value: false,
                    });
                });
        },
        async updateVisibility({ commit }, payload) {
            const { headers } = useApi();

            await api
                .post("/api/numbers/update-visibility", payload, { headers })
                .then((response) => {
                    const { status, description } = response.data;
                    commit(
                        "setToastContent",
                        {
                            status,
                            description: `${
                                payload.visibility
                                    ? "page.integration.numbers_table.invisible_toast.available_number"
                                    : "page.integration.numbers_table.invisible_toast.invisible_number"
                            }`,
                        },
                        { root: true }
                    );
                })
                .catch((error) => {
                    commit("setToastContent", error.response.data, {
                        root: true,
                    });
                    throw error;
                });
        },
        // async refreshApiKey(index, type) {
        // TODO: ПЕРЕПИСАТЬ МЕТОД
        async refreshNumberApiKey({ commit }, payload) {
            const { headers } = useApi();
            // console.log(payload);

            try {
                const response = await api.post(
                    "/api/numbers/update-api-key",
                    payload,
                    {
                        headers,
                    }
                );
                const { status, description } = response.data;
                commit(
                    "setToastContent",
                    {
                        status: "success",
                        description: "dialog.refresh_api_key.toast_success",
                    },
                    { root: true }
                );
            } catch (error) {
                commit(
                    "setToastContent",
                    {
                        status: "error",
                        description: "dialog.refresh_api_key.toast_error",
                    },
                    { root: true }
                );
                throw error;
            }
        },
        async addTag({ commit }, payload) {
            const { headers } = useApi();

            try {
                const response = await api.post("/api/tags", payload, {
                    headers,
                });
                const { status, description } = response.data;
                commit(
                    "setToastContent",
                    {
                        status: status.toLowerCase(),
                        description: "tags.add_tag_success",
                    },
                    { root: true }
                );
                return response.data;
            } catch (error) {
                commit(
                    "setToastContent",
                    {
                        status: "error",
                        description: "tags.add_tag_error",
                    },
                    { root: true }
                );
                throw error;
            }
        },
        async editTag({ commit }, payload) {
            const { headers } = useApi();
            try {
                const response = await api.put(
                    `/api/tags/${payload.id}`,
                    payload,
                    { headers }
                );
                const { status, description } = response.data;
                commit(
                    "setToastContent",
                    {
                        status: status.toLowerCase(),
                        description: "tags.edit_tag_success",
                    },
                    { root: true }
                );
                return response.data;
            } catch (error) {
                commit(
                    "setToastContent",
                    {
                        status: "error",
                        description: "tags.edit_tag_error",
                    },
                    { root: true }
                );
                throw error;
            }
        },

        async removeTag({ commit }, payload) {
            const { headers } = useApi();
            try {
                const response = await api.delete(
                    `/api/tags/${payload.id}/numbers/${payload.number}/messengers/${payload.messenger}`,
                    { headers }
                );
                const { status, description } = response.data;
                commit(
                    "setToastContent",
                    {
                        status: status.toLowerCase(),
                        description: "tags.delete_tag_success",
                    },
                    { root: true }
                );
                return response.data;
            } catch (error) {
                commit(
                    "setToastContent",
                    {
                        status: "error",
                        description: "tags.delete_tag_error",
                    },
                    { root: true }
                );
                throw error;
            }
        },
    },

    mutations: {
        SET_PRESELECTED_NUMBERS_BY_MSG(state, payload) {
            state.preselectedNumbers[payload.msg] = [...payload.data];
        },

        SET_OLD_NUMBERS_VIBER(state, data) {
            state.numbersViber = data;
        },

        SET_OLD_NUMBERS_TELEGRAM(state, data) {
            state.numbersTelegram = data.filter((item) => item.number != 0);
        },
        SET_NUMBERS_VIBER(state, [data, visibility]) {
            if (visibility) {
                state.numbersDataViber[0] = data;
            } else {
                state.numbersDataViber[1] = data;
            }
        },
        SET_NUMBERS_TELEGRAM(state, [data, visibility]) {
            // state.numbersDataTelegram = data.filter((item) => item.number != 0);
            if (visibility) {
                state.numbersDataTelegram[0] = data;
            } else {
                state.numbersDataTelegram[1] = data;
            }
        },
        SET_NUMBERS_WHATSAPP(state, [data, visibility]) {
            if (visibility) {
                state.numbersDataWhatsapp[0] = data;
            } else {
                state.numbersDataWhatsapp[1] = data;
            }
        },
        SET_NUMBER_LIST_PAGINATION_VIBER(state, [paginationData, visibility]) {
            if (visibility) {
                state.numbersDataAttributes.numberListPagination.viber[0] =
                    paginationData;
            } else {
                state.numbersDataAttributes.numberListPagination.viber[1] =
                    paginationData;
            }
        },
        SET_NUMBER_LIST_PAGINATION_TELEGRAM(
            state,
            [paginationData, visibility]
        ) {
            if (visibility) {
                state.numbersDataAttributes.numberListPagination.telegram[0] =
                    paginationData;
            } else {
                state.numbersDataAttributes.numberListPagination.telegram[1] =
                    paginationData;
            }
        },
        SET_NUMBER_LIST_PAGINATION_WHATSAPP(
            state,
            [paginationData, visibility]
        ) {
            if (visibility) {
                state.numbersDataAttributes.numberListPagination.whatsapp[0] =
                    paginationData;
            } else {
                state.numbersDataAttributes.numberListPagination.whatsapp[1] =
                    paginationData;
            }
        },
        SET_SEARCH_INPUT_VIBER(state, [input, visibility]) {
            if (visibility) {
                state.numbersDataAttributes.searchInput.viber[0] = input;
            } else {
                state.numbersDataAttributes.searchInput.viber[1] = input;
            }
        },
        SET_SEARCH_INPUT_TELEGRAM(state, [input, visibility]) {
            if (visibility) {
                state.numbersDataAttributes.searchInput.telegram[0] = input;
            } else {
                state.numbersDataAttributes.searchInput.telegram[1] = input;
            }
        },
        SET_SEARCH_INPUT_WHATSAPP(state, [input, visibility]) {
            if (visibility) {
                state.numbersDataAttributes.searchInput.whatsapp[0] = input;
            } else {
                state.numbersDataAttributes.searchInput.whatsapp[1] = input;
            }
        },
        SET_SELECTED_NUMBERS(state, data) {
            state.selectedNumbers = data;
        },
        SET_LOADING_NUMBERS_VIBER(state, [value, visibility]) {
            if (visibility) {
                state.numbersDataAttributes.loading.viber[0] = value;
            } else {
                state.numbersDataAttributes.loading.viber[1] = value;
            }
        },
        SET_LOADING_NUMBERS_TELEGRAM(state, [value, visibility]) {
            if (visibility) {
                state.numbersDataAttributes.loading.telegram[0] = value;
            } else {
                state.numbersDataAttributes.loading.telegram[1] = value;
            }
        },
        SET_LOADING_NUMBERS_WHATSAPP(state, [value, visibility]) {
            if (visibility) {
                state.numbersDataAttributes.loading.whatsapp[0] = value;
            } else {
                state.numbersDataAttributes.loading.whatsapp[1] = value;
            }
        },
        // !!! TODO:переписать логику!!! ЗАТРОНЕТ ВСЕ ЛОГИЧЕСКИЕ КОМПОНЕНТЫ ЧТО СВЯЗАНЫ С ВЕБХУКАМИ
        UPDATE_WEBHOOKS(state, { webhooks, el }) {},
        RESET_ALL_STATE(state) {
            state.getDefaultState();
        },
    },
};

export default numbersModule;
